const E2P_PRODUCTION_URL = "https://ui-e2p.knackgalaxy.com";
const E2P_QE_URL = "https://ui-qe2p.knackgalaxy.com";

export const getE2pBaseUrl = () => {
  if (process.env.NODE_ENV === "production") {
    return E2P_PRODUCTION_URL;
  }
  const fromEnv = process.env.REACT_APP_E2P_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim();
  }
  return E2P_QE_URL;
};

export const getE2pRedirectUrl = (token) =>
  `${getE2pBaseUrl()}?token=${encodeURIComponent(token)}`;
